/**
 * @author Jorge Casas
 * @creationDate 03/07/2024
 */

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/**
 * @function generateCodesLabelByAssetPDF
 *
 * @description Function to generate a PDF with the QR and Barcode of an asset
 *
 * @param {string} qrUrl - The URL of the QR code
 * @param {string} barcodeUrl - The URL of the Barcode
 * @returns {Promise} - The PDF with the QR and Barcode
 * @throws {Promise} - The error message
 */
export const generateCodesLabelByAssetPDF = async (qrUrl, barcodeUrl) => {
  console.log('Generating PDF with base64 data');

  try {
    let qrCodeBase64 = '';
    let barcodeBase64 = '';

    if (qrUrl && qrUrl !== '') {
      const qrResponse = await fetch(qrUrl);
      const qrBuffer = await qrResponse.arrayBuffer();
      qrCodeBase64 = Buffer.from(qrBuffer).toString('base64');
    }

    if (barcodeUrl && barcodeUrl !== '') {
      const barcodeResponse = await fetch(barcodeUrl);
      const barcodeBuffer = await barcodeResponse.arrayBuffer();
      barcodeBase64 = Buffer.from(barcodeBuffer).toString('base64');
    }

    const docDefinition = {
      content: [
        /* {
          text: 'Etiquetas de Código por Activo',
          style: 'header',
        },
        {
          text: 'Código QR:',
          style: 'subheader',
        }, */
        {
          image: `data:image/jpeg;base64,${qrCodeBase64}`,
          width: 150,
          alignment: 'center',
          margin: [0, 225, 0, 20],
        },
       /*  {
          text: 'Código de Barras:',
          style: 'subheader',
        }, */
        {
          image: `data:image/jpeg;base64,${barcodeBase64}`,
          width: 300,
          alignment: 'center',
          margin: [0, 10, 0, 20],
        },
      ],
      styles: {
        header: {
          fontSize: 22,
          bold: true,
          alignment: 'center',
          margin: [0, 20, 0, 10],
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 5],
        },
      },
    };

    pdfMake.createPdf(docDefinition).open();
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw { code: 500, message: 'Error generating PDF' };
  }
};



// WEBPACK FOOTER //
// src/lib/pdfs/AssetsCodesLabel.js